import type { FaireBrandEntity } from "../../entity_types/brand";

export const b_1jpuiv57: FaireBrandEntity = {
  token: "b_1jpuiv57",
  type: "brand",
  name: "gold + ivy",
  avatarUrl:
    "https://cdn.faire.com/fastly/6796eca4a15a8a726342433d6b1cd04094cd49889af75aa6e9053b6c85ebb280.png",
  bannerUrl:
    "https://cdn.faire.com/fastly/cc628c3a54920c7d72d7597f1f290f6830206c53c277f1e722330e29893da71c.jpeg",
  logoUrl:
    "https://cdn.faire.com/fastly/6796eca4a15a8a726342433d6b1cd04094cd49889af75aa6e9053b6c85ebb280.png",
  heroImageUrl:
    "https://cdn.faire.com/fastly/cc628c3a54920c7d72d7597f1f290f6830206c53c277f1e722330e29893da71c.jpeg",
  location: "Nashville, TN, USA",
  minimumOrderDollars: 100,
  rating: 5,
  reviewCount: 117,
  isTopShop: true,
  isInsider: true,
  description:
    "gold + ivy is a female founded + operated candle company based in nashville, tn. we believe the objects you buy for your home should create a calm + intentional environment. that's why we created gold + ivy, to help create a shift in your mood + mindset. \n\n\nevery gold + ivy candle is hand poured in our nashville studio using 100% american grown soy wax, cotton wicks, + phthalate-free non-toxic fragrance oils. also, our candles are always + forever cruelty-free!\n\n\ng+i owner, Alexis, is a transplants to Nashville from New Jersey. She loves craft beer, live music, and is super excited to get to know you + your shop! ",
  meta: {
    source: "api",
    importedAt: "2026-08-15T03:50:43.960Z",
    importedBy: "entity-db-cli",
  },
};
